import React, { Component, Fragment } from "react";
import NoDataComponent from "../NoDataComponent";
import { connect } from "react-redux";
import api from "../../utility/api/api.js";
import {
  assignedJobsAction,
  completedJobsAction,
  actionProcessingJobs,
  actionIntransitJob,
  pendingJobsAction,
} from "../../actions/index";
import { bindActionCreators } from "redux";
import Loader from "react-loader";
import PendingAmount from "../Assigned/PendingAmount";
import PendingJobs from "../Assigned/PendingJobs";
const MyLoader = (WrappedComponent, props) => {
  class MyLoader extends Component {
    componentDidMount() {
      switch (props) {
        case "delivered":
          // api.getcompletedjobs(this);
          api.callAssignedJobs(this, "delivered");
          // api.acceptJobList(this);
          break;
        case "assigned":
          console.log("Guna001");
          api.callAssignedJobs(this, "assigned");
          break;
        case "intransit":
          api.callAssignedJobs(this, "in-transit");
          break;
        default:
          break;
      }
    }
    render() {
      return (
        <Fragment>
          {this.props[props] === null || this.props.intransitJob == null ? (
            <Loader
              loaded={false}
              lines={13}
              length={20}
              width={10}
              radius={30}
              corners={1}
              rotate={0}
              direction={1}
              color="#e51837"
              speed={1}
              trail={60}
              shadow={false}
              hwaccel={false}
              className="spinner"
              zIndex={2e9}
              top="50%"
              left="50%"
              scale={1.0}
              loadedClassName="loadedContent"
            />
          ) : ((props == "delivered" || props == "intransit") &&
              this.props[props] === "failure") ||
            (props == "assigned" &&
              this.props[props] === "failure" &&
              this.props.intransitJob == "failure") ? (
            <div className="maincontent container">
              {props === "assigned" ? <PendingAmount /> : ""}
              <NoDataComponent nodata={props} />
            </div>
          ) : (
            <WrappedComponent jobs={this.props[props]} />
          )}
          {props === "assigned" ? <PendingJobs /> : ""}
        </Fragment>
      );
    }
  }
  function mapStateToProps(state) {
    console.log("assignedassigned", state);
    return {
      delivered: state.completedJobs,
      intransit: state.processingJobs,
      assigned: state.getjobs,
      intransitJob: state.intransitJob,
    };
  }
  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        completedJobsAction: completedJobsAction,
        assignedJobsAction: assignedJobsAction,
        actionProcessingJobs: actionProcessingJobs,
        actionIntransitJob: actionIntransitJob,
      },
      dispatch
    );
  }
  return connect(mapStateToProps, mapDispatchToProps)(MyLoader);
};
export default MyLoader;



// WEBPACK FOOTER //
// ./src/components/HOC/MyLoader.js